import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legal-document-revenue-impact',
  templateUrl: './legal-document-revenue-impact.component.html',
  styleUrls: ['./legal-document-revenue-impact.component.css']
})
export class LegalDocumentRevenueImpactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
